import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { removeNotification } from '../app/slices/notificationsSlice'

import { Notification, NotificationGroup } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";

export const Notifications = () => {
    const notifications = useSelector((state) => state.notifications.value);
    const dispatch = useDispatch();

    const getNotificationComponent = (key, type, text) => {
        return (<Fade>
            <Notification
                type={{
                    style: type,
                    icon: true,
                }}
                closable={true}
                onClose={() => dispatch(removeNotification(key))}
            >
                <span>{text}</span>
            </Notification>
        </Fade>);
    }

    return (
        <NotificationGroup>
            {notifications.map(obj => getNotificationComponent(obj.key, obj.type, obj.text))}
        </NotificationGroup>
    )
}